import AppSwitcherIcon from "@v2assets/AppSwitcherIcon.svg";
import ZomentumLogoIcon from "@v2assets/ZomentumIcon.svg";
import ZomentumLogo from "@v2assets/ZomentumLogo.svg";
import ZomentumPaymentIcon from "@v2assets/ZomentumPaymentIcon.svg";

import React, { memo, useState } from "react";
import ZTooltip from "@atoms/ZTooltip";
import ZTypography from "@atoms/ZTypography";
import { AnimatePresence, motion } from "framer-motion";
import { IAppSwitcher } from "./interface";
import ZIcon from "@atoms/ZIcon";
import { EIcons } from "@atoms/ZIcon/interface";
import { EColors } from "@atoms/ZColors/interface";

const AppSwitcher: React.FC<IAppSwitcher> = ({
	growUrl,
	paymentUrl,
	paymentsAppSwitchEnabled
}) => {
	const [appSwitchPanelOpen, setAppSwitchPanelOpen] =
		useState<boolean>(false);
	return (
		<div className="pl-2">
			<ZTooltip
				title="Zomentum Apps"
				mouseEnterDelay={1}
				placement="right"
			>
				<div
					className="flex p-1 hover:bg-gray-3 cursor-pointer"
					onClick={() => setAppSwitchPanelOpen(!appSwitchPanelOpen)}
				>
					<AppSwitcherIcon />
				</div>
			</ZTooltip>
			{appSwitchPanelOpen && (
				<div
					onClick={() => setAppSwitchPanelOpen(false)}
					className="absolute top-0 left-0 w-screen h-screen bg-gray-6 opacity-50 transition-opacity duration-500 z-10"
				/>
			)}
			<AnimatePresence>
				{appSwitchPanelOpen && (
					<motion.aside
						key="modal"
						className="absolute w-70 top-0 left-0 z-100 h-screen drop-shadow-md z-20 bg-gray-1"
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0 }}
					>
						<div className="flex items-center justify-between pl-4 pr-5 py-5">
							<div
								className="flex p-1 hover:bg-gray-3 cursor-pointer"
								onClick={() => setAppSwitchPanelOpen(false)}
							>
								<AppSwitcherIcon />
							</div>
							<ZomentumLogo className="m-0" />
						</div>
						<div className="grid grid-cols-1">
							<a
								className="pl-8 py-4 flex items-center justify-start cursor-pointer group hover:bg-gray-2"
								onClick={() => setAppSwitchPanelOpen(false)}
								href={growUrl}
							>
								<ZomentumLogoIcon className="h-6 w-6 m-0" />
								<ZTypography.ZText
									className="ml-5 font-medium"
									level={2}
								>
									Grow
								</ZTypography.ZText>
								<ZIcon
									name={EIcons.ARROWRIGHT}
									color={EColors.BLUE}
									colorVariant={6}
									className="group-hover:block hidden mr-6"
								/>
							</a>
							{paymentsAppSwitchEnabled ? (
								<a
									className="pl-8 py-4 flex items-center justify-start cursor-pointer group hover:bg-gray-2"
									href={paymentUrl}
									onClick={() => setAppSwitchPanelOpen(false)}
									target="_blank"
									rel="noreferrer"
								>
									<ZomentumPaymentIcon className="h-6 w-6 m-0" />
									<ZTypography.ZText
										className="ml-5 font-medium"
										level={2}
									>
										Payments
									</ZTypography.ZText>
									<ZIcon
										name={EIcons.ARROWRIGHT}
										color={EColors.BLUE}
										colorVariant={6}
										className="group-hover:block hidden mr-6"
									/>
								</a>
							) : (
								<div className="pl-8 py-4 flex items-center justify-start cursor-not-allowed group bg-gray-3">
									<ZomentumPaymentIcon className="h-6 w-6 m-0" />
									<ZTypography.ZText
										className="ml-5 font-medium"
										level={2}
									>
										Payments (Coming soon)
									</ZTypography.ZText>
								</div>
							)}
						</div>
					</motion.aside>
				)}
			</AnimatePresence>
		</div>
	);
};

export default memo(AppSwitcher);
